import { getSiteConfig, siteDefaults } from "@/lib/site-config";

export { siteDefaults, getSiteConfig };
export type { SiteConfig } from "@/lib/site-config";

/** Resolved site config (defaults + NEXT_PUBLIC_SITE_* env overrides). */
export const site = getSiteConfig();
